import React  from "react";
import man from "../img/smartphone_man_stand.png";

class Profile extends React.Component {
  render() {
    return (
      <div id ="profile">
        <h1 className="title">Profile</h1>
        <div id="introduce">
            <img src={man} alt="画像"/>
            {/* <ul>
                <li>Name : Nagasawa Ryohei</li>
                <li>Age : 20</li>
                <li>Skill : HTML, CSS, SCSS, PHP, Ruby, Ruby on rails, JavaScript, Python, React</li>
                <li>Career : Toyo University Faculty of Information Sciences and Arts</li>
                <br/>
                <li>名前：ナガサワ リョウヘイ</li>
                <li>年齢：20歳</li>
                <li>スキル：HTML, CSS, SCSS, PHP, Ruby, Ruby on rails, JavaScript, Python, React</li>
                <li>経歴：東洋大学 総合情報学部</li>
          </ul> */}
          <table>
            <tbody>
              <tr>
                <td>Name : </td>
                <td>Nagasawa Ryohei</td>
              </tr>
              <tr>
                <td>Age : </td>
                <td>20</td>
              </tr>
              <tr>
                <td>Skill : </td>
                <td>HTML, CSS, SCSS, PHP, JavaScript, React, Vue</td>
              </tr>
              <tr>
                <td>Career : </td>
                <td>Toyo University Faculty of Information Sciences and Arts</td>
              </tr>
              <br />
              <tr>
                <td>名前：</td>
                <td>ナガサワ リョウヘイ</td>
              </tr>
              <tr>
                <td>年齢：</td>
                <td>20歳</td>
              </tr>
              <tr>
                <td>スキル：</td>
                <td>HTML, CSS, SCSS, PHP, JavaScript, React, Vue</td>
              </tr>
              <tr>
                <td>経歴：</td>
                <td>東洋大学 総合情報学</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default Profile;
